import Button from './Button/index.vue';
import Modal from './Modal/index.vue';
import Dropdown from './Dropdown/index.vue';
import Input from './Input/index.vue';
import Select from './Select/index.vue';
import SearchableSelect from './SearchableSelect/index.vue';
import Radio from './Radio/index.vue';
import Checkbox from './CheckBox/index.vue';
import Breadcrumb from './Breadcrumb/index.vue';
import NoData from '@c/common/NoData.vue';
import SvgIcon from '@/components/common/Icon.vue';
import Segmented from './Segmented/index.vue';
import nTabs from './Tabs/index.vue';
import nPagination from './Pagination/index.vue';
import DatePicker from './DatePicker/index.vue';
import Backnav from './Backnav/index.vue';
import Switch from './Switch/index.vue';
import Tooltip from './Tooltip/index.vue';
import CountUp from './CountUp/index.vue';
import Avatar from './Avatar/index.vue';
import Token from './Token/index.vue';
import Copy from './Copy/index.vue';
export default {
  install: (Vue:any) => {
    Vue.component('Button', Button);
    Vue.component('Modal', Modal);
    Vue.component('Dropdown', Dropdown);
    Vue.component('Input', Input);
    Vue.component('Select', Select);
    Vue.component('SearchableSelect', SearchableSelect);
    Vue.component('Checkbox', Checkbox);
    Vue.component('Radio', Radio);
    Vue.component('NTabs', nTabs);
    Vue.component('NoData', NoData);
    Vue.component('SvgIcon', SvgIcon);
    Vue.component('Segmented', Segmented);
    Vue.component('NPagination', nPagination);
    Vue.component('DatePicker', DatePicker);
    Vue.component('Breadcrumb', Breadcrumb);
    Vue.component('Backnav', Backnav);
    Vue.component('Switch', Switch);
    Vue.component('Tooltip', Tooltip);
    Vue.component('CountUp', CountUp);
    Vue.component('Avatar', Avatar);
    Vue.component('Token', Token);
    Vue.component('Copy', Copy);
  }
};
